import React from 'react';
import MainHeader from './MainHeader';
import Layout from './Layout';
import GoToTop from './GoToTop';

export default function MainLayoutContact({ children }) {
  return (
   
    <React.Fragment>
    <Layout>
      <MainHeader />
      {children}
      <GoToTop/>
    </Layout>
  </React.Fragment>


  )
}
